import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getQuoteToolStorageKey } from '@lx/quote-tool/lite/shared/types';
import { SessionStorageService } from '@lx/shared/storage';
import { QuoteToolLiteStore } from '../store';

@Injectable({ providedIn: 'root' })
export class PersistentStoreService {
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly sessionStorageService = inject(SessionStorageService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly storageKey = getQuoteToolStorageKey();

  /**
   * It persists the state of the quote tool lite store in the session storage.
   * It is listening the state observable and when it changes, it saves the state into the session storage.
   */
  initializePersistingState() {
    this.quoteToolLiteStore.state$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((state) => {
      const {
        currentStep,
        activeFlow,
        selectedLanguage,
        selectedSchoolLocation,
        selectedCourse,
        selectedDuration,
        selectedAyaDuration,
        selectedStartDate,
        selectedEndDate,
        selectedTimezone,
        tripDates,
        selectedAccommodation,
        selectedInsuranceCode,
        selectedUnaccompaniedMinorRows,
        selectedProfessionalImmersionExperienceCode,
        selectedTransferRows,
        selectedCurrency,
        selectedResidence,
        studentDetails,
        selectedPremiumAccommodationCode,
        selectedPrivateLesson,
        juniorCourseUpgrade,
        selectedPremiumActivities,
        selectedClassTime,
        flywireCheckoutSessionData,
        depositAmounts,
        requestedQuotes,
      } = state;
      this.sessionStorageService.set(this.storageKey, {
        currentStepId: currentStep?.id,
        activeFlow,
        selectedLanguage,
        selectedSchoolLocation,
        selectedAyaDuration,
        selectedCourse,
        selectedDuration,
        selectedStartDate,
        selectedEndDate,
        selectedTimezone,
        tripDates,
        selectedAccommodation,
        selectedInsuranceCode,
        selectedUnaccompaniedMinorRows,
        selectedProfessionalImmersionExperienceCode,
        selectedTransferRows,
        selectedCurrency,
        selectedResidence,
        studentDetails,
        selectedPremiumAccommodationCode,
        juniorCourseUpgrade,
        selectedPrivateLesson,
        selectedPremiumActivities,
        selectedClassTime,
        flywireCheckoutSessionData,
        depositAmounts,
        requestedQuotes,
      });
    });
  }
}
